document.addEventListener('DOMContentLoaded', function() {
  // 1. Get elements with null checks
  const progressBar = document.querySelector('[data-progress-bar]');
  const progressContainer = document.querySelector('[data-product-gallery-progress]');
  const mediaList = document.querySelector('[data-product-gallery-list]');
  if (!progressBar || !progressContainer || !mediaList) return;

  // 2. Make progress bar always visible
  progressContainer.style.display = 'block';
  
  // 3. Calculate the exact number of scrollable "steps"
  function countScrollSteps() {
    const firstSlide = mediaList.querySelector('[data-media]');
    if (!firstSlide) return 1;
    
    const slideWidth = firstSlide.offsetWidth;
    const totalScroll = mediaList.scrollWidth - mediaList.clientWidth;
    return Math.max(1, Math.round(totalScroll / slideWidth));
  }

  const scrollSteps = countScrollSteps();
  const progressIncrement = 100 / (scrollSteps + 1);
  
  // 4. Initialize progress
  progressBar.style.width = `${progressIncrement}%`;
  console.log(`Config: ${scrollSteps} steps, ${progressIncrement.toFixed(2)}% increment`);

  // 5. Update progress during scroll
  mediaList.addEventListener('scroll', function() {
    const maxScroll = mediaList.scrollWidth - mediaList.clientWidth;
    if (maxScroll <= 0) return;
    
    const scrollRatio = mediaList.scrollLeft / maxScroll;
    const currentStep = Math.min(
      Math.round(scrollRatio * scrollSteps),
      scrollSteps
    );
    const progress = (currentStep + 1) * progressIncrement;
    progressBar.style.width = `${Math.min(100, progress)}%`;
  });

  // 6. Enhanced click handler
  progressContainer.addEventListener('click', function(e) {
    const clickX = e.clientX - this.getBoundingClientRect().left;
    const clickPercent = clickX / this.offsetWidth;
    const targetStep = Math.min(
      Math.floor(clickPercent * (scrollSteps + 1)),
      scrollSteps
    );
    const targetScroll = (targetStep / scrollSteps) * (mediaList.scrollWidth - mediaList.clientWidth);
    mediaList.scrollTo({ left: targetScroll, behavior: 'smooth' });
  });
});